import { cn } from "@/lib/utils";
import { Skeleton } from "..";

export default function ProductCardSkeleton({
  className,
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <Skeleton
      className={cn(
        "rounded-xl bg-putty-light h-[332px] min-w-[270px] w-full flex items-end border",
        className,
      )}
    >
      <div className="bg-white w-full p-6 pt-4 rounded-b-xl h-2/4">
        <div className="bg-putty-light mb-6 h-[20px]"></div>
        <div className="bg-putty-light mb-2 h-[95px] pt-4"></div>
      </div>
    </Skeleton>
  );
}
